import React from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { Auth } from '@aws-amplify/auth';
import { useLocation } from 'react-router';
import { useAppContext } from '../libs/ContextLibs';
import ForgotPassword from '../layout/ForgotPassword';
import queryString from 'query-string';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 9,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 5,
    span: 20,
  },
};

export default function Login(props) {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const reset = params.reset === 'true';
  const token = params.token;
  const step = parseInt(params.step);
  const { setIsAuthenticated, setUser } = useAppContext();

  async function onFinish(values) {
    try {
      await Auth.signIn(values.username, values.password).then(async () => {
        setIsAuthenticated(true);
        setUser(await Auth.currentUserInfo());
      });
      const timestamp = new Date().toISOString();
      // Call API to persist last login in MongoDB Users collection
      const info = await Auth.currentUserInfo();

      const userId =  info?.username;

      try {
        await fetch('/api/users/last-login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            lastLoggedIn: timestamp,
          }),
        }).then(async (res) => {
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.error || `Failed to update last login (${res.status})`);
          }
        });
      } catch (err) {
        console.error('Failed to persist last login:', err);
      }

    } catch (e) {
      message.error(e.message);
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <div style={{ background: '#fff', padding: 20, minHeight: '100%' }}>
        <div className='login-page'>
          <div className='content'>
            <img src='/niq-lg-rgb-pos.png' width='300px' alt='Nielsen IQ' />
            <Card bordered={false} style={{ width: 1000 }}>
              <Form
                {...layout}
                name='basic'
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label='Email'
                  name='username'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label='Password'
                  name='password'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <ForgotPassword reset={reset} code={token} step={step} />
                  <Button
                    type='primary'
                    size='large'
                    shape='round'
                    htmlType='submit'
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
